import { GetterTree } from 'vuex';
import { LicenseState, ActiveInfo } from './types';
import { RootState } from '../../types';

const getActive = state => (): ActiveInfo => state.active.activeInfo;

export const getters: GetterTree<LicenseState, RootState> = {
    active: state => getActive(state),
};
